import Bugsnag from '@bugsnag/js'
import Script from 'next/script'

const OneTrustTag = () => {
  const dataDomainScript =
    process.env.NODE_ENV === 'production'
      ? 'be58f70f-be59-46ac-bf8e-aa62756e4867'
      : 'be58f70f-be59-46ac-bf8e-aa62756e4867-test'

  return (
    <Script
      id="onetrust-script-1"
      key="oneTrust"
      src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
      data-domain-script={dataDomainScript}
      onError={(error) => {
        Bugsnag.notify(error, (event) => {
          event.context = 'OneTrust CDN Cookie Law Script Erroring'
        })
      }}
      strategy="lazyOnload"
    />
  )
}

export default OneTrustTag
